<ion-list mode="ios" lines="none" class="list-content">
  <ion-item
    mode="md"
    lines="none"
    color="white"
    class="ion-text-center item-data"
  >
    <ion-label mode="md" color="status-icon-enable" class="help-delivery">
      {{ "Labels.help-delivery" | translate }}
    </ion-label>
  </ion-item>
</ion-list>
